import { StateCreator } from 'zustand';
import { DocumentTemplateTypes } from '../../constants';
import { DocgenClient } from '../../data/docgenClient';
import { handleErrorWithServerMessage } from '../../data/errorHandler';
import {
	DocumentTemplate,
	DocumentTemplateType,
} from '../../data/interfaces/DocumentTemplate';
import { t } from '../../utils';
import { storeResetFns } from '.';

type State = {
	documentTemplate: DocumentTemplate;
};

type Actions = {
	createDocumentTemplate: (templateType?: DocumentTemplateType) => Promise<string>;
	getDocumentTemplate: (id?: string) => Promise<DocumentTemplate>;
	updateDocumentTemplate: (data: Partial<DocumentTemplate> | DocumentTemplate) => void;
};

export type DocumentTemplateState = State & Actions;

const initialState = {
	documentTemplate: null,
};

export const createDocumentTemplateSlice: StateCreator<DocumentTemplateState> = (
	set,
	get
) => {
	storeResetFns.add(() => {
		set(initialState);
	});
	return {
		...initialState,
		createDocumentTemplate: async (templateType = DocumentTemplateTypes.Static.type) => {
			try {
				const createTemplateResponse =
					await DocgenClient.createTemplate<DocumentTemplate>(templateType);

				set({
					documentTemplate: createTemplateResponse,
				});
				return createTemplateResponse.rid;
			} catch {
				handleErrorWithServerMessage(t('errorMessages.createDocumentTemplateError'));
			}
		},
		getDocumentTemplate: async rid => {
			const { documentTemplate } = get();

			const templateRID = rid || documentTemplate?.rid;

			try {
				// eslint-disable-next-line @typescript-eslint/no-shadow
				const documentTemplate = await DocgenClient.getTemplateByRID<DocumentTemplate>(
					templateRID
				);

				if (documentTemplate) {
					set({
						documentTemplate,
					});
				}
				return documentTemplate;
			} catch {
				handleErrorWithServerMessage(t('errorMessages.getDocumentTemplateError'));
				return null;
			}
		},
		updateDocumentTemplate: (data: Partial<DocumentTemplate> | DocumentTemplate) => {
			const { documentTemplate } = get();
			set({
				documentTemplate: { ...documentTemplate, ...data },
			});
		},
	};
};
